import { ApolloError } from '@apollo/client'
import Bugsnag from '@bugsnag/js'
import BugsnagPluginReact from '@bugsnag/plugin-react'
import { VERSION } from '@salescore/buff-common'
import { logger } from '@salescore/frontend-common'

import { getAuth0UserFromLocalStorage } from './getAuth0UserFromLocalStorage'

const auth0User = getAuth0UserFromLocalStorage()
if (process.env.BUGSNAG_API_KEY !== undefined) {
  Bugsnag.start({
    apiKey: process.env.BUGSNAG_API_KEY,
    appVersion: VERSION,
    releaseStage: process.env.APP_ENV,
    plugins: [new BugsnagPluginReact()],
    user: {
      id: auth0User?.sub,
      name: auth0User?.name,
      email: auth0User?.email,
    },
  })
}

export const notifyBugsnag = ({
  error,
  severity,
  metadata,
}: {
  error: Error
  severity?: 'error' | 'warning' | 'info'
  metadata?: {
    key: string
    value: Record<string, string | number | boolean | undefined | Record<string, unknown>>
  }
}) => {
  const auth0User = getAuth0UserFromLocalStorage()
  if (process.env.BUGSNAG_API_KEY === undefined) {
    logger.debug(`[bugsnag] not notified.`, { error, severity, metadata, auth0User })
    return
  }

  Bugsnag.notify(error, (event) => {
    // eslint-disable-next-line no-param-reassign
    event.severity = severity ?? 'error'
    // eslint-disable-next-line @typescript-eslint/strict-boolean-expressions
    if (auth0User) {
      event.setUser(auth0User.sub, auth0User.email, auth0User.name)
      // event.addMetadata(`auth0`, auth0User) // 現状一緒なので不要
    }
    if (metadata !== undefined) {
      event.addMetadata(metadata.key, metadata.value)
    }
  })
}

// ApolloError については ApolloClient 内で notifyBugsnag するのでスルーする
export const notifyBugsnagFromErrorBoundary = ({ error }: { error: Error }): void => {
  if (error instanceof ApolloError) {
    return
  }
  notifyBugsnag({ error })
}
